(() => {
  const SELECTOR = '[data-tm-cinematic-film]';
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  const initialize = (root) => {
    if (!root || root.dataset.tmFilmInitialized === 'true') return;
    root.dataset.tmFilmInitialized = 'true';

    const frame = root.querySelector('[data-tm-film-frame]');
    const video = root.querySelector('[data-tm-film-video]');
    const toggle = root.querySelector('[data-tm-film-toggle]');
    const icon = root.querySelector('[data-tm-film-icon]');
    if (!frame || !video || !toggle || !icon) return;

    const autoplay = root.dataset.autoplay === 'true';
    const connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
    const normalWarmupMargin = root.dataset.pageType === 'product' ? '1200px 0px' : '260px 0px';
    const sourceWarmupMargin = connection?.saveData ? '0px 0px' : /(^|-)2g$/.test(connection?.effectiveType || '') ? '320px 0px' : normalWarmupMargin;
    let inView = false;
    let userPaused = false;

    const updateControl = (playing) => {
      const shape = playing ? 'M6 5h4v14H6zM14 5h4v14h-4z' : 'M8 5v14l11-7z';
      icon.innerHTML = `<svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" focusable="false"><path d="${shape}"/></svg>`;
      toggle.setAttribute('aria-label', playing ? toggle.dataset.pauseLabel : toggle.dataset.playLabel);
      toggle.setAttribute('aria-pressed', playing ? 'true' : 'false');
    };

    const attachSource = () => {
      if (video.getAttribute('src')) return;
      const isMobile = window.matchMedia('(max-width: 749px)').matches;
      const source = isMobile ? video.dataset.mobileSrc : video.dataset.desktopSrc;
      if (!source) return;
      video.src = source;
      video.load();
    };

    const play = () => {
      if (document.hidden || !inView || userPaused || reduceMotion.matches || !autoplay) return;
      attachSource();
      const request = video.play();
      if (request && typeof request.catch === 'function') request.catch(() => updateControl(false));
    };

    video.addEventListener('loadeddata', () => frame.classList.add('is-ready'), { once: true });
    video.addEventListener('playing', () => updateControl(true));
    video.addEventListener('pause', () => updateControl(false));

    toggle.addEventListener('click', () => {
      inView = true;
      if (!video.paused) {
        userPaused = true;
        video.pause();
        return;
      }
      userPaused = false;
      attachSource();
      const request = video.play();
      if (request && typeof request.catch === 'function') request.catch(() => updateControl(false));
    });

    if ('IntersectionObserver' in window) {
      const sourceObserver = new IntersectionObserver((entries, observer) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          if (!reduceMotion.matches) attachSource();
          observer.unobserve(entry.target);
        });
      }, { rootMargin: sourceWarmupMargin, threshold: 0 });
      sourceObserver.observe(frame);

      const playbackObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          inView = entry.isIntersecting;
          if (inView) play();
          else if (!video.paused) video.pause();
        });
      }, { threshold: 0.42 });
      playbackObserver.observe(frame);
    } else if (!reduceMotion.matches) {
      inView = true;
      attachSource();
      play();
    }

    document.addEventListener('visibilitychange', () => {
      if (document.hidden && !video.paused) video.pause();
      else play();
    });
  };

  const initializeAll = (scope = document) => {
    scope.querySelectorAll(SELECTOR).forEach(initialize);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeAll(), { once: true });
  } else {
    initializeAll();
  }

  document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
})();
